import classNames from 'classnames';

type LoaderProps = {
  className?: string;
};

function Loader({ className }: LoaderProps) {
  return (
    <div
      className={classNames('animate-pulse rounded bg-slate-300/70', className)}
      data-testid="loader"
    ></div>
  );
}

export default Loader;
